import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { useQuery } from '@tanstack/react-query';
import { getArticles } from '@dealstack/frontend/app/services/Blog.service.ts';
import { ApplicationType } from '@dealstack/shared/lib/generated';
import { ClientPerspective } from '@sanity/client';

interface ArticlesParams {
	enabled: boolean;
	language?: string;
	refId?: string;
	limit?: number;
	searchKeyword?: string;
}

export const useArticles = (
	dataset: ApplicationType,
	{ language, refId, limit, enabled, searchKeyword }: ArticlesParams,
	perspective?: ClientPerspective
) => {
	const { data, isFetching } = useQuery({
		queryKey: [
			API_PATHS.HELP_BLOG_DATASET_ARTICLES_GET,
			{ dataset, perspective, language, refId, limit, searchKeyword },
		],
		queryFn: () =>
			getArticles(API_PATHS.HELP_BLOG_DATASET_ARTICLES_GET, {
				dataset,
				perspective,
				language,
				refId,
				limit,
				searchKeyword,
			}),
		enabled,
	});

	return {
		articles: data || [],
		isFetching,
	};
};
